/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  id: number;
  agency: {
    id: number;
    name: string;
  };
  app: {
    id: number;
    appGroup: {
      id: number;
      name: string;
    };
    trackingVendor: {
      id: number;
      name: string;
    };
    os: string;
    appId: string;
  };
  redSegmentId: number;
  twitterUserId: string;
  twitterSegmentId: string;
  name: string;
  deliveryRate: number;
  startAt: string;
  endAt: string;
  extractedAt?: string;
  downloadUrl: string;
  createdAt: string;
  updatedAt: string;
};

export type IndexParams = {
  appId: number;
};

export type CreateParams = {
  appId?: number;
  twitterSegmentId?: string;
  name?: string;
  deliveryRate?: number;
  startAt?: string;
  endAt?: string;
};

export type UpdateParams = {
  twitterSegmentId?: string;
  name?: string;
  deliveryRate?: number;
  startAt?: string;
  endAt?: string;
};

export class Api {
  public static index(agencyId: number, params: IndexParams) {
    return request.get<IndexResponse[]>(
      `/agencies/${agencyId}/churn_segments`,
      params
    );
  }

  public static create(agencyId: number, params: CreateParams) {
    return request.post(`/agencies/${agencyId}/churn_segments`, params);
  }

  public static update(agencyId: number, id: number, params: UpdateParams) {
    return request.post(`/agencies/${agencyId}/churn_segments/${id}`, params);
  }
}
